import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewEncapsulation
} from '@angular/core';
import {BehaviorSubject, Observable, of, Subject} from 'rxjs';
import {debounceTime, delay, distinctUntilChanged, takeUntil} from 'rxjs/operators';

@Component({
  selector: 'app-input-filter-dropdown',
  templateUrl: './input-filter-dropdown.component.html',
  styleUrls: ['./input-filter-dropdown.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class InputFilterDropdownComponent implements OnInit, OnChanges, OnDestroy {

  @Input()
  selectedItemInternal: string = '';
  @Input()
  title: string = '';
  @Input()
  items: any[];
  @Input()
  displayField: string = ''; //use this field when working with list of objects to specify field to show in multiple select
  @Input()
  placeholder = '';
  @Input()
  customStyle: any;
  @Input()
  hasError = false;
  @Input()
  disabled = false;
  @Input()
  asterix = false;
  @Input()
  inputId = `input-filter-${Math.random().toString(36).slice(2)}`;

  @Output()
  public itemSelect: Observable<any>;
  @Output()
  selectedItem = new EventEmitter<any>();
  @Output()
  searchTerm = new EventEmitter<string>();

  private readonly searchSubject = new BehaviorSubject<string>('');
  private readonly unsubscribeAll$ = new Subject<void>();

  ngOnInit() {
    this.searchSubject
      .pipe(
        takeUntil(this.unsubscribeAll$),
        distinctUntilChanged(),
        debounceTime(400)
      )
      .subscribe(term => {
        this.searchTerm.emit(term);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items)
      this.itemSelect = of(changes.items.currentValue).pipe(delay(1));
  }

  selectedChanged($event: any) {
    this.selectedItem.emit($event);
  }

  onSearch($event: { term: string; items: any[] }) {
    this.searchSubject.next($event.term);
  }

  ngOnDestroy(): void {
    this.unsubscribeAll$.next();
    this.unsubscribeAll$.complete();
  }
}
